import KendoListView from './KendoListView'
import KendoPager from './KendoPager'
import KendoListViewInstaller from './kendo-listview-installer'

export {
    KendoListView, KendoListView as ListView, KendoPager, KendoPager as Pager, KendoListViewInstaller, KendoListViewInstaller as ListViewInstaller
}


// WEBPACK FOOTER //
// ./packages/kendo-listview-vue-wrapper/src/index.js